<template>
    <div>
        <a-button @click="showModal" class="btn-outline-primary">
            سانس ها
        </a-button>

        <a-modal width="1000px" v-model="visible" title=" سانس های سمینار" on-ok="handleOk">
            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    بستن
                </a-button>

            </template>
            <form @submit.prevent="addData($event)">

            <div class="row">
                <div class="col-md-6">
                    <div class="form-group text-right">
                        <label for="">ساعت پایان</label>
                        <input v-model="sans.end_hour" name="start_hour" type="number" class="form-control">


                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group text-right">
                        <label for="">ساعت شروع</label>
                        <input v-model="sans.start_hour" name="end_hour" type="number" class="form-control">

                    </div>
                    <input name="seminar_id" type="hidden" :value="seminar.id">

                </div>
                <div class="mt-1">
                    <button type="submit" class="btn btn-fill btn-outline-success ">
                                        ذخیره
                                    </button>
                </div>
            </div>
            </form>
            <hr>
            <div>
                <table class="table ">
                    <thead>
                        <tr>
                            <th scope="col"> </th>
                            <th scope="col"> ساعت پایان</th>
                            <th scope="col">ساعت شروع</th>
                            <th scope="col">شناسه</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="sans in seminar.sans">
                            <td>
                                <!-- <a-button class="btn-outline-warning" icon="delete" type="link"
                                @click="deleteRow(sans.id)"></a-button> -->

                            </td>
                            <td>

                                <b-badge variant="light" class="text-dark">{{ sans . start_hour }}</b-badge>
                            </td>
                            <td>


                                <b-badge variant="light" class="text-dark">{{ sans . end_hour }}</b-badge>
                            </td>
                            <th scope="row">#{{ sans . id }}</th>


                        </tr>
                    </tbody>
                </table>
            </div>

        </a-modal>
    </div>
</template>
<script>
    export default {
        props: {
            seminar: Object,
        },
        data() {
            return {
                loading: false,
                visible: false,
                sans:{
                    start_hour:'',
                    end_hour:''
                },
            };
        },
        methods: {
            addData(event) {
                let _this = this;
                let data = new FormData(event.target);
                _this.$root.loading = true;
                axios
                    .post("/seminars/sans", data)
                    .then(function(response) {
                        console.log(response)
                        _this.$root.loading = false;
                        _this.seminar.sans.push(response.data.data)
                        _this.sans={};
                        _this.$toast.success(" سانس سمینار با موفقیت افزوده شد");
                    })
                    .catch(function(err) {
                        _this.$root.loading = false;
                        _this.$root.handleAxiosError(err);
                    });
            },
            deleteRow(id) {
                this.$swal({
                    title: "آیا از حذف اطلاعات اطمینان دارید؟",
                    showDenyButton: true,
                    showCancelButton: false,
                    confirmButtonText: "بله",
                    denyButtonText: "لغو",
                }).then((result) => {
                    if (result.isConfirmed) {
                        let _this = this;
                        axios
                            .get(`seminars/sans/delete/${id}`)
                            .then(function(response) {
                                _this.seminar.sans = _this.seminar.sans.filter((e)=>e.id !== id )
                                _this.$toast.success("با موفقیت حذف شد.");

                            })
                            .catch(function(err) {
                                _this.$root.handleAxiosError(err);
                            });
                    }
                });
            },
            showModal() {
                this.visible = true;
            },
            handleOk(e) {
                this.loading = true;
                setTimeout(() => {
                    this.visible = false;
                    this.loading = false;
                }, 3000);
            },
            handleCancel(e) {
                this.visible = false;
            },
            
        },
    };
</script>
